"use strict";

var _toConsumableArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var types_1 = require("../types");

var TransactionQueue_1 = require("../entities/TransactionQueue");

var PostTransactionResolver_1 = require("../PostTransactionResolver");

var PolymathError_1 = require("../PolymathError"); // NOTE @RafaelVidaurre: We could add a preparation state cache to avoid repeated transactions and bad validations

/**
 * @hidden
 * Represents an operation performed on the Polymath ecosystem. A Procedure can be prepared to yield a Transaction Queue
 * that can be run
 */


var Procedure = // eslint-disable-next-line require-jsdoc
function Procedure(args, context) {
  var _this = this;

  _classCallCheck(this, Procedure);

  this.type = types_1.ProcedureType.UnnamedProcedure;
  this.transactions = [];
  this.fees = [];
  /**
   * Mandatory method that builds a list of transactions that will be
   * run
   */

  this.prepare = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var returnValue, totalFees, transactionQueue;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.prepareTransactions();

            case 2:
              returnValue = _context.sent;
              totalFees = this.fees.reduce(function (_ref, _ref2) {
                var usd = _ref.usd,
                    poly = _ref.poly;
                var newUsd = _ref2.usd,
                    newPoly = _ref2.poly;
                var polySum = poly.plus(newPoly);
                var usdSum;

                if (usd === null && newUsd === null) {
                  usdSum = null;
                } else {
                  usdSum = (usd || new contract_wrappers_1.BigNumber(0)).plus(newUsd || new contract_wrappers_1.BigNumber(0));
                }

                return {
                  usd: usdSum,
                  poly: polySum
                };
              }, {
                usd: null,
                poly: new contract_wrappers_1.BigNumber(0)
              });
              transactionQueue = new TransactionQueue_1.TransactionQueue(this.transactions, totalFees, returnValue, this.args, this.type);
              return _context.abrupt("return", transactionQueue);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };
  /**
   * Appends a Procedure into the TransactionQueue's queue. This defines
   * what will be run by the TransactionQueue when it is started.
   *
   * @param Proc - A Procedure that will be run in the Procedure's TransactionQueue
   *
   * @returns whichever value is returned by the Procedure
   */


  this.addProcedure = function (Proc) {
    return function (args) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var operation, returnValue, transactions, fees;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                operation = new Proc(args, this.context);
                _context2.prev = 1;
                _context2.next = 4;
                return operation.prepareTransactions();

              case 4:
                returnValue = _context2.sent;
                _context2.next = 15;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);

                if (!(_context2.t0.code === types_1.ErrorCode.ProcedureValidationError)) {
                  _context2.next = 13;
                  break;
                }

                throw _context2.t0;

              case 13:
                if (_context2.t0 instanceof PolymathError_1.PolymathError) {
                  _context2.next = 15;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: _context2.t0.message
                });

              case 15:
                transactions = operation.transactions, fees = operation.fees;
                this.fees = [].concat(_toConsumableArray(this.fees), _toConsumableArray(fees));
                this.transactions = [].concat(_toConsumableArray(this.transactions), _toConsumableArray(transactions));
                return _context2.abrupt("return", returnValue);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));
    };
  };
  /*
   * TODO @monitz87: add an array of PostTransactionResolvers whose resolved values get passed
   * as an optional parameter to the resolver functions (same concept as futureValue but for resolver functions)
   */

  /**
   * Appends a method or future method into the TransactionQueue's queue. This defines
   * what will be run by the TransactionQueue when it is started.
   *
   * @param method - A method (or future method) that will be run in the Procedure's TransactionQueue.
   * A future method is a transaction that doesn't exist at prepare time
   * (for example a transaction on a module that hasn't been attached but will be by the time the previous transactions are run)
   * @param options.tag - An optional tag for SDK users to identify this transaction, this
   * can be used for doing things such as mapping descriptions to tags in the UI
   * @param options.fee - Value in POLY of the transaction (defaults to 0)
   * @param options.resolver - An asynchronous callback used to provide runtime data after
   * the added transaction has finished successfully
   *
   * @returns a PostTransactionResolver that resolves to the value returned by the resolver function, or undefined if no resolver function was passed
   */


  this.addTransaction = function (method) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        tag = _ref3.tag,
        fees = _ref3.fees,
        _ref3$resolvers = _ref3.resolvers,
        resolvers = _ref3$resolvers === void 0 ? [] : _ref3$resolvers;

    return function (args) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var postTransactionResolvers, transaction;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                postTransactionResolvers = resolvers.map(function (resolver) {
                  return new PostTransactionResolver_1.PostTransactionResolver(resolver);
                });

                if (fees) {
                  this.fees.push(fees);
                }

                transaction = {
                  method: method,
                  args: args,
                  postTransactionResolvers: postTransactionResolvers,
                  tag: tag
                };
                this.transactions.push(transaction);
                return _context3.abrupt("return", postTransactionResolvers);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
  };
  /**
   * Appends a signature request into the TransactionQueue's queue. This defines
   * what will be run by the TransactionQueue when it is started.
   *
   * @param request - A signature request that will be run in the Procedure's TransactionQueue
   *
   * @returns a PostTransactionResolver that resolves to the signed data
   */


  this.addSignatureRequest = function (request) {
    return function (args) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var postTransactionResolver, transaction;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                postTransactionResolver = new PostTransactionResolver_1.PostTransactionResolver(function (receipt) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4() {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            return _context4.abrupt("return", receipt);

                          case 1:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                });
                transaction = {
                  method: request,
                  args: args,
                  postTransactionResolvers: [postTransactionResolver],
                  tag: types_1.PolyTransactionTag.Signature
                };
                this.transactions.push(transaction);
                return _context5.abrupt("return", postTransactionResolver);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
  };

  this.args = args;
  this.context = context;
};

exports.Procedure = Procedure;